export const CONTEXTUAL_ONBOARDING_ENABLED = false;

export function useOnboardingGate(): boolean {
    return CONTEXTUAL_ONBOARDING_ENABLED;
}
